import { useOrgNavMode } from '../../client/contexts/OrgNavModeContext';

/**
 * Secondary panel for landing page navigation.
 * (Deprecated: Landing pages and their configs were removed during project genericization)
 */
export function LandingSecondaryPanel({ primarySidebarWidth, isVisible }: { primarySidebarWidth: number; isVisible: boolean }) {
  return null;
}
